/**
 * Core functionality for the enhanced grid system
 * Handles initialization, loading management, and common utilities
 */

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing core module');
  
  // Create loading manager to track asset loading
  if (!window.appState) {
    window.appState = {
      loadingComplete: false,
      progress: 0,
      readyToShow: false
    };
  }
  
  // Global timeout to ensure loading completes
  const loadingTimeout = setTimeout(() => {
    console.log('Loading timeout reached, forcing completion');
    window.appState.progress = 100;
    window.appState.readyToShow = true;
    updateLoadingProgress();
  }, 10000); // 10 seconds max loading time
  
  // Assets to load
  const assets = {
    productImages: { loaded: 0, total: 0, weight: 0.4 }, // 40% of progress
    glbModel: { loaded: false, weight: 0.6 } // 60% of progress
  };
  
  // Get main elements
  const container = document.getElementById('product-grid-container');
  const grid = document.getElementById('product-grid');
  const products = document.querySelectorAll('.product-card');
  
  // Check if we have the required elements
  if (!container || !grid || products.length === 0) {
    console.error('Required elements not found');
    // Still allow page to load
    window.appState.progress = 100;
    window.appState.readyToShow = true;
    return;
  }
  
  console.log(`Found ${products.length} products`);
  
  // Set up product image loading tracking
  assets.productImages.total = products.length;
  
  // Set up Three.js and GLTFLoader
  let THREE, GLTFLoader;
  
  // Load required libraries
  loadRequiredLibraries();
  
  /**
   * Load Three.js and GLTFLoader libraries
   */
  function loadRequiredLibraries() {
    const loadScript = (url, callback) => {
      console.log(`Loading script: ${url}`);
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.onload = callback;
      script.onerror = (err) => {
        console.error(`Failed to load script: ${url}`, err);
        callback(); // Call callback anyway to not block loading
      };
      document.head.appendChild(script);
    };
    
    // Load Three.js first, then GLTFLoader
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js', () => {
      console.log('THREE.js loaded via script tag');
      THREE = window.THREE;
      
      loadScript('https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/GLTFLoader.min.js', () => {
        console.log('GLTFLoader loaded via script tag');
        GLTFLoader = window.THREE.GLTFLoader;
        
        // Now initialize the application since libraries are loaded
        init();
      });
    });
  }
  
  /**
   * Update the loading progress based on assets loaded
   */
  function updateLoadingProgress() {
    // Calculate product images progress (0-100%)
    const productImagesProgress = assets.productImages.total > 0 
      ? (assets.productImages.loaded / assets.productImages.total) * 100 
      : 100;
    
    // Calculate GLB model progress (0 or 100%)
    const glbModelProgress = assets.glbModel.loaded ? 100 : 0;
    
    // Weighted total progress
    const totalProgress = 
      (productImagesProgress * assets.productImages.weight) + 
      (glbModelProgress * assets.glbModel.weight);
    
    // Update global app state
    window.appState.progress = totalProgress;
    
    // Check if everything is loaded
    if (productImagesProgress >= 100 && glbModelProgress >= 100) {
      console.log('All assets loaded successfully!');
      window.appState.loadingComplete = true;
      window.appState.readyToShow = true;
      clearTimeout(loadingTimeout); // Cancel timeout if loading completes normally
    }
  }
  
  // Initialize app components
  function init() {
    // Make sure the grid has proper positioning
    grid.style.position = 'relative';
    grid.style.width = '100%';
    grid.style.height = '100%';
    
    // Initialize product cards module
    if (window.ProductCards) {
      window.ProductCards.init(grid, products, assets, updateLoadingProgress);
    }
    
    // Initialize draggable functionality
    if (window.DraggableElements) {
      window.DraggableElements.init(products);
    }
    
    // Initialize 3D model
    if (window.ThreeDModel) {
      window.ThreeDModel.init(grid, THREE, GLTFLoader, assets, updateLoadingProgress);
    }
    
    // Listen for window resize
    window.addEventListener('resize', function() {
      if (window.ProductCards) {
        window.ProductCards.randomizePositions();
      }
    });
  }
  
  // Make functions available globally
  window.GridCore = {
    updateLoadingProgress: updateLoadingProgress,
    assets: assets
  };
});
